import { RESERVE_ORDER_STATUS } from "../config/constants";

export enum RESERVATION_DISPLAY_TYPE {
  /**
   * 常规预约
   */
  NORMAL = 1,
  /**
   * 专项活动
   */
  SPECIAL = 2,
}

/**
 * 容量类型
 */
export enum CAPACITY_TYPE {
  /**
   * 常规容量
   */
  NORMAL = 'normal',
  /**
   * 专项容量
   */
  SPECIAL = 'specail'
}

export interface ReservationItemTypes {
  displayType: RESERVATION_DISPLAY_TYPE;
  name: string;
  uuid: string;
  desc: string;
  checked?: boolean;
  children: ReserveItemChildrenTypes[];
  code?: number;
  eventCode?: string;
}

export interface ReserveItemChildrenTypes {
  code: number;
  displayType: RESERVATION_DISPLAY_TYPE;
  name: string;
  uuid: string;
  desc: string;
  checked?: boolean;
  // child: [],
}

export interface DATE_RANGE_ITEM {
  checked?: boolean;
  date: string;
  weekDate: string;
  state: number;
  reserveQuota: number;
  weekDayDesc: string;
  dateDesc: string;
  timestamp: number;
  ruleItems: TIME_RANGE_ITEM[];
}

export interface TIME_RANGE_ITEM {
  checked?: boolean;
  canReserveNumber: number;
  date: string;
  endTime: string;
  startTime: string;
}

export interface DATE_RANGE_STORE_ITEM {
  checked?: boolean;
  date: string;
  dateDesc: string;
  timestamp: number;
  shopDetailResps: STORE_ITEMS_CAPACITY[];
}

export interface STORE_ITEMS_CAPACITY {
  checked?: boolean;
  uuid: string;
  city: string;
  cityCode: string;
  date: string;
  code: string;
  linkAddr: string;
  linkTel: string;
  name: string;
  lat: number;
  lot: number;
  distance: number;
  isDriving: number;
  isUserDefaultShop: number;
  groupFive: null | number;
  shopTags: null | string[];
  tags: null | string[];
  canReserveNumber?: number;
  ruleItems: TIME_RANGE_ITEM[];
}

export interface ProvinceTypes {
  id: number;
  label: string;
  value: string;
  children: CityTypes[];
}

export interface CityTypes {
  id: number;
  pid: number;
  label: string;
  value: string;
}

export interface ReservingItemTypes {
  id: number;
  uuid: string;
  code: number;
  preComeDate: number;
  bookingTime: number;
  oasOrderCode: string;
  shopCode: string;
  shopName: string;
  orderTypeText: string;
  status: RESERVE_ORDER_STATUS;
  statusName: string;
  isDrivingOrder: number;
  pickupAddress: string;
  allowCancel: boolean;
}

export interface ReserveAdviceTypes {
  currentMileage: number;
  lastMaintainDate: number;
  lastMaintainMileage: number;
  maintainStatus: number;
  nextMaintainDate: number;
  nextMaintainMileage: number;
  type: number;
}

export interface ReserveMaintainInfoTypes {
  desc: string;
  items: MaintainItemTypes[];
  maintainType: number;
}

interface MaintainItemTypes {
  item: string;
  number: number;
  type: number;
}

export interface ReserveOrderTypes {
  id: number;
  reserveId: number;
  reserveUuid: string;
  reserveOrderCode: string;
  code: number;
  csDesc: string;
  orderType: string;
  reserveTel: string;
  reserveMan: string;
  preComeDate: number;
  bookingDate: number;
  oasOrderCode: string;
  shopCode: string;
  shopName: string;
  orderTypeText: string;
  status: RESERVE_ORDER_STATUS;
  statusName: string;
  isDrivingOrder: number;
  pickupAddress: {
    address: string;
    remark: "";
    longitude: number;
    latitude: number;
  } | null;
  bookingTime: string;
  allowCancel: boolean;
  vin: string;
  plateNumber: string;
  descList: string[];
  serviceTime: number;
  drivingDto: {
    drivingAddress: string;
    pickupLat: number;
    pickupLng: number;
    pickupAddress: string;
  } | null;
  shopAddress: {
    address: string;
    code: string;
    latitude: number;
    longitude: number;
    name: string;
    remark: string;
    shopUuid: string;
    telephone: string;
    cityCode: string;
    cityName: string;
  } | null;
  specialActivityCode: string;
}

export interface TimeDataTypes {
  timestamp: number;
  weekDate?: string;
  date: string;
  startTime: string;
}
